<template>
  <div
    class="clear-all-facets-fi"
    @click="$emit('click')"
  >
    <span>
      {{ $dict.get('facets.Clear-All-Facets') }}
    </span>
    <icon-fi icon="close" />
  </div>
</template>

<script>
import { IconFi } from 'atoms';

export default {
  name: 'ClearAllFacetsFi',
  components: {
    IconFi,
  },
  emits: ['click'],
};
</script>

<style scoped lang="scss">
@import './clear-all-facets-fi';
</style>
